var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1654 10.0003L17.132 7.68365L17.4154 4.61698L14.407 3.93365L12.832 1.28365L9.9987 2.50031L7.16536 1.28365L5.59036 3.93365L2.58203 4.60865L2.86536 7.67531L0.832031 10.0003L2.86536 12.317L2.58203 15.392L5.59036 16.0753L7.16536 18.7253L9.9987 17.5003L12.832 18.717L14.407 16.067L17.4154 15.3836L17.132 12.317L19.1654 10.0003ZM8.33203 14.167L4.9987 10.8336L6.1737 9.65864L8.33203 11.8086L13.8237 6.31698L14.9987 7.50031L8.33203 14.167Z",
    fill: "#90A955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiVerified);
export default __webpack_public_path__ + "static/media/mdi_verified.afe6fbbd5b97adc9f30878650a3f3ce8.svg";
export { ForwardRef as ReactComponent };